export const recommendationsSlug = 'recommendations'
export const ALL_RECIPES_COLLECTION_ID = 'ca8f71be-63ac-11e6-a693-068306404bab'
